<template>
  <div
    ref="el"
    class="loading-spinner pointer-events-none grid grid-cols-3 grid-rows-3"
    :style="animate ? {} : { animation: 'none' }"
  >
    <div
      v-for="i in 9"
      :key="i"
      :style="{
        ...(animate ? {} : { animation: 'none' }),
      }"
    >
      <div :style="innerDivStyle" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementSize } from '@vueuse/core';

withDefaults(defineProps<{ animate?: boolean }>(), {
  animate: true,
});

const el = ref<HTMLDivElement>();

const { width } = useElementSize(el);

const innerDivStyle = computed(() => {
  return {
    backgroundSize: `${width.value}px`,
  };
});
</script>

<style lang="scss">
.loading-spinner {
  animation: spin 3s infinite ease-in-out;

  & > div {
    animation: cube 3s infinite ease-in-out;
  }
}

.loading-spinner > div > div {
  height: 100%;
  width: 100%;
  background-image: url("/img/streamlabs-app-icon.png");
  background-position: -9999px -9999px;
  background-repeat: no-repeat;
}

.loading-spinner div:nth-child(1) {
  animation-delay: 200ms;
}

.loading-spinner div:nth-child(1) div {
  border-radius: 6px 0 0 0;
  background-position: 0% 0%;
}

.loading-spinner div:nth-child(2) {
  animation-delay: 300ms;
}
.loading-spinner div:nth-child(2) div {
  background-position: 50% 0%;
}

.loading-spinner div:nth-child(3) {
  animation-delay: 400ms;
}
.loading-spinner div:nth-child(3) div {
  border-radius: 0 6px 0 0;
  background-position: 100% 0%;
}

.loading-spinner div:nth-child(4) {
  animation-delay: 100ms;
}
.loading-spinner div:nth-child(4) div {
  background-position: 0% 50%;
}

.loading-spinner div:nth-child(5) {
  animation-delay: 200ms;
}
.loading-spinner div:nth-child(5) div {
  background-position: 50% 50%;
}

.loading-spinner div:nth-child(6) {
  animation-delay: 300ms;
}
.loading-spinner div:nth-child(6) div {
  background-position: 100% 50%;
}

.loading-spinner div:nth-child(7) {
  animation-delay: 0ms;
}
.loading-spinner div:nth-child(7) div {
  border-radius: 0 0 0 6px;
  background-position: 0% 100%;
}

.loading-spinner div:nth-child(8) {
  animation-delay: 100ms;
}
.loading-spinner div:nth-child(8) div {
  background-position: 50% 100%;
}

.loading-spinner div:nth-child(9) {
  animation-delay: 200ms;
}
.loading-spinner div:nth-child(9) div {
  border-radius: 0 0 6px 0;
  background-position: 100% 100%;
}

@keyframes spin {
  0% {
    transform: rotate3d(0, 0, 1, -360deg);
  }

  20% {
    transform: rotate3d(0, 0, 1, 0deg);
  }
}

@keyframes cube {
  0%,
  20%,
  100% {
    transform: scale(1, 1);
  }

  10% {
    transform: scale(0, 0);
  }
}
</style>
